<div class="flex flex-col gap-2">
  <p class="text-xl">Http Error Code:&nbsp;<span class="font-bold text-red-800">{{ error.errorCode }}</span></p>
  <p>{{ error.error.message ?? error.message }}</p>
  @if (!isProduction) {
    <hr>
      @if (!showMore()) {
        <button (click)="showMore.set(true)"
          class="px-4 py-2 rounded bg-accent-500">
          <ng-container i18n>Show more details</ng-container>
        </button>
      }
      @if (showMore()) {
        <eurogard-any-http-error></eurogard-any-http-error>
      }
    }
  </div>
